import {
  Breadcrumbs,
  EntityToolbar,
  HeaderWithScrollables,
  IEntityWork,
  useEntityPageStore,
  useEnvironment,
} from '@diana/core';
import { Box } from '@mui/material';
import { routeUrls } from '../../app/Routing/RouteUrls';
import { useBreadcrumbsRoot } from '../../hooks/useBreadcrumbsRoot';

interface IHeaderProps {
  entityId: string;
  entity?: IEntityWork;
  peoplePage?: boolean;
}

export function Header(props: IHeaderProps) {
  const { entityId, entity, peoplePage } = props;
  const environment = useEnvironment();
  const breadcrumbRoot = useBreadcrumbsRoot(peoplePage ? 'people' : 'assets');

  const showSidePeek = useEntityPageStore(
    (store) => store.flow?.featureFlags?.isSingleScreenWorkUpdate,
  );

  const breadCrumbsPeople = {
    title: entity?.displayName || entity?.entityType || '...',
  };

  const breadcrumbsAssets = [
    {
      title: entity?.flowDisplayName || entity?.entityType || '...',
      link: routeUrls[peoplePage ? 'people' : 'things'].url(
        {
          environment,
          flowOriginId: entity?.flowOriginId || '',
        },
        null,
      ),
    },
    { title: `${entity?.displayName}`, hidden: !entity },
  ];

  const breadcrumbs = peoplePage
    ? [breadcrumbRoot, breadCrumbsPeople]
    : [breadcrumbRoot, ...breadcrumbsAssets];

  const leftHeader = <Breadcrumbs items={breadcrumbs} />;
  const rightHeader = (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      {entity ? (
        <EntityToolbar
          entityId={entityId}
          entity={entity}
          isPeoplePage={peoplePage}
          showSidePeek={showSidePeek}
        />
      ) : null}
    </Box>
  );

  return <HeaderWithScrollables left={leftHeader} right={rightHeader} />;
}
